import * as ng from 'angular';
import {TMP_BUCKET} from '../config';

declare var gapi: any;

/* global gapi */
declare global {

  // tslint:disable-next-line:interface-name
  interface String {
    beforeLastIndex: (name: string, delimiter: string) => string;
    afterLastIndex: (name: string, delimiter: string) => string;
  }

  // tslint:disable-next-line:interface-name
  interface FileReader {
    readAsBinaryStringForChunk: (fileData: any) => void;
  }

}

String.prototype.beforeLastIndex = (name: string, delimiter: string): string => {
  return name.substr(0, name.lastIndexOf(delimiter)) || name + '';
};
String.prototype.afterLastIndex = (name: string, delimiter: string): string => {
  return name.lastIndexOf(delimiter) === -1 ? '' : name.substr(name.lastIndexOf(delimiter) + 1);
};


class GoogleAPI {
  private PROJECT: string = 'curious-subject-694';
  private clientId: string = '1012733794228-12fs0e5naqqoriisr10em9gog9rhj8v6.apps.googleusercontent.com';
  private apiKey: string = 'AIzaSyBDyjQJVt7o97DmunQTalawJ66vfVN8020';
  private scopes: string = 'https://www.googleapis.com/auth/devstorage.full_control';
  private API_VERSION: string = 'v1';
  private GROUP: string = '00b4903a977ca83f7b316b0dc6d5ff6541c8cd3b5115822eb0fe90984c78235b';
  private listApiRequestExplanations: any = {
    listBuckets: `This API call queries the Google Cloud Storage API
                for a list of buckets in your project, and returns the result as
                a list of Google Cloud Storage buckets.`,
    listObjects: `This API call queries the Google Cloud Storage API
                for a list of objects in your bucket, and returns the result as
                a list of Google Cloud Storage objects.`,
    listBucketsAccessControls: `This API call queries the Google Cloud
                Storage API for the list of access control lists on buckets in your
                project and returns the result as a list of Google Cloud Storage
                Access Control Lists.`,
    listObjectsAccessControls: `This API call queries the Google Cloud
                Storage API for the list of access control lists on objects in your
                bucket and returns the result as a list of Google Cloud Storage
                Access Control Lists.`,
    getBucket: `This API call queries the Google Cloud Storage API
                for a bucket in your project, and returns the result as a
                Google Cloud Storage bucket.`,
    getBucketAccessControls: `This API call queries the Google Cloud
                Storage API for the access control list on a specific bucket
                and returns the result as a Google Cloud Storage Access Control List.`,
    getObjectAccessControls: `This API call queries the Google Cloud
                Storage API for the access control list on a specific object
                and returns the result as a Google Cloud Storage Access Control List.`,
    insertBucket: `This API call uses the Google Cloud Storage API
                to insert a bucket into your project.`,
    insertObject: `This API call uses the Google Cloud Storage API
                to insert an object into your bucket.`,
    insertBucketAccessControls: `This API uses the Google Cloud
                Storage API to insert an access control list on a specific bucket
                and returns the result as a Google Cloud Storage Access Control List.`,
    insertObjectAccessControls: `This API uses the Google Cloud
                Storage API to insert an access control list on a specific object
                and returns the result as a Google Cloud Storage Access Control List.`,
    deleteBucket: `This API uses the Google Cloud Storage API to delete
                an empty bucket and returns an empty response to indicate success.`,
    deleteObject: `This API uses the Google Cloud Storage API to delete
                an object and returns an empty response to indicate success.`
  };
  private accessToken: any;

  public getAccessToken() {
    this.accessToken = localStorage.getItem('_GoogleAccessToken');
    return this.accessToken;
  }

  public setAccessToken(accessToken: any) {
    localStorage.setItem('_GoogleAccessToken', accessToken);
  }

  public initializeApi() {
    gapi.client.setApiKey(this.apiKey);
    gapi.client.load('storage', this.API_VERSION);
  }

  public insertObject(fileData: any, dropzoneId: any, storageFolder: any, username: any, callback: any, callbackProgress?: any, bucket?: any, newFileNames?: any, archiDriveRootPath?: any) {

    // https://cloud.google.com/storage/docs/exponential-backoff#example_algorithm
    let maximum_backoff_milliseconds = 32000;
    let maximum_backoff_attempts = 5;

    // get angular  $rootScope
    let $body: any = ng.element(document.body);
    let $rootScope: any = $body.scope().$root;

    // add a random folder before username to avoid overwriting files with same name
    let guid = $rootScope.guid();

    let BUCKET: string = '';
    if (bucket === undefined) {
      BUCKET = TMP_BUCKET;
    } else {
      BUCKET = bucket;
    }

    let fileNameExtension = fileData.name.afterLastIndex(fileData.name, '.');
    let uniqueFileName = fileData.name.beforeLastIndex(fileData.name, '.') + $rootScope.guid() + (fileNameExtension === '' ? '' : '.' + fileNameExtension);

    let parentFolder = archiDriveRootPath ? storageFolder + '/' + (bucket === undefined ? username + '_' : '') : `${storageFolder}/${guid}/`;
    let fileName = newFileNames ? newFileNames[fileData.name] : (bucket === undefined ? `${username}_` : '') + fileData.name;
    let googleFilePath = archiDriveRootPath ? archiDriveRootPath + uniqueFileName : parentFolder + fileName;

    let executeRequest = (attempt) => {
      try {
        $rootScope.ArchiSmallServices.uploadFile(fileData, BUCKET, googleFilePath).then(res => {
          if (res === false) {
            // -2 because starts from 0 and because it arrives here after the request is made
            if (attempt > maximum_backoff_attempts - 2) {
              callback(dropzoneId, false, fileData.name);
              return;
            }

            setTimeout(
              function () {
                executeRequest(attempt + 1);
              }, Math.min(Math.pow(2, attempt) * 1000 + Math.floor(Math.random() * 1000) + 1, maximum_backoff_milliseconds));

          } else {

            let successCallback = () => {
              callback(dropzoneId, res, fileData.name);
              if (callbackProgress) {
                callbackProgress(100);
              }
            };
            let errorCallback = () => { /* */
            };
            let settings = {
              'auditType': 1,
              'file_id': res.id,
              'storage_file_name': res.name,
              'file_parent_folder': parentFolder,
              'file_name': fileName
            };
            $rootScope.audit(settings, successCallback, errorCallback);
          }
        });

      } catch (e) {
        alert('googleAPI.insertObject: An error has occurred: ' + e.message);
      }
    };
    executeRequest(0);
  }

  public insertObjectInChunks(fileData: any, dropzoneId: any, storageFolder: any, username: any, callback: any, callbackProgress: any, testEnvironment: any, bucket: any, newFileNames: any, archiDriveRootPath: any) {
    // update the progress
    if (callbackProgress !== null && callbackProgress !== undefined) {
      callbackProgress(0);
    }
    // get angular  $rootScope
    let $body = ng.element(document.body);
    let $rootScope: any = $body.scope().$root;
    let fileNameExtension = fileData.name.afterLastIndex(fileData.name, '.');
    let uniqueFileName = fileData.name.beforeLastIndex(fileData.name, '.') + $rootScope.guid() + (fileNameExtension === '' ? '' : '.' + fileNameExtension);
    let googleFilePath = archiDriveRootPath + uniqueFileName;
    let archiDriveFileParentFolder = storageFolder + '/' + (bucket === undefined ? username + '_' : '');
    let archiDriveFileName = newFileNames[fileData.name];
    // add a random folder before username to avoid ovewriting files with same name
    let BUCKET: string = '';
    if (bucket === undefined) {
      BUCKET = TMP_BUCKET;
      // da togliere BUCKET = 'l001tmp';
      // if (testEnvironment) {
      //     da togliere BUCKET = 'dev1_temp';
      // }
    } else {
      BUCKET = bucket;
    }

    let chunkSize = 2 * 256 * 1024; // bytes
    let fileBytesCount = 0;
    let contentType = fileData.type || 'application/octet-stream';

    let metadata = {
      'name': googleFilePath,
      'mimeType': contentType
    };
    let multipartRequestBody = JSON.stringify(metadata);
    let request = gapi.client.request({
      'path': `/upload/storage/${this.API_VERSION}/b/${BUCKET}/o`,
      'method': 'POST',
      'params': {'uploadType': 'resumable'},
      'headers': {
        'Authorization': 'Bearer ' + this.getAccessToken(),
        // 'Content-Type': contentType,
        'X-Upload-Content-Type': contentType,
        'X-Origin': 'http://localhost:3000'
      },
      'body': multipartRequestBody
    });
    let uploadUrl = '';
    let getUploadUrl = (ret, raw) => {
      try {
        let obj = $.parseJSON(raw);
        // on chrome is location
        // tslint:disable-next-line:no-string-literal
        uploadUrl = obj.gapiRequest['data']['headers']['location'];
        if (uploadUrl === undefined) {
          // on FF is Location
          // tslint:disable-next-line:no-string-literal
          uploadUrl = obj.gapiRequest['data']['headers']['Location'];
        }

        if (uploadUrl === undefined) {
          callback(dropzoneId, false, fileData.name);
        }
        chunkFile(fileData, uploadChunk, this);
      } catch (err) {
        callback(dropzoneId, false, fileData.name);
      }
    };

    function uploadChunk(chunk: any, offset: any, callbackUploadDone: any, $scope: any) {
      let chunkBase64 = btoa(chunk);
      let chunkBytesCount = chunk.length;
      fileBytesCount += chunkBytesCount;
      let contentRange = ' bytes ' + offset + '-' + (offset + chunkBytesCount - 1) + '/*';
      if (chunk.length < chunkSize) {
        contentRange = ' bytes ' + offset + '-' + (offset + chunkBytesCount - 1) + '/' + fileBytesCount;
      }
      let requestUploadChunk = gapi.client.request({
        path: uploadUrl, // uri got from previous request
        method: 'PUT',
        headers: {
          'Content-Encoding': 'base64', // uploading with base64 works
          // "Content-Transfer-Encoding": "base64",
          'Content-Type': fileData.type || 'application/octet-stream',
          // "Content-Length": ss.length,
          'Content-Range': contentRange,
          'Authorization': `Bearer ` + $scope.getAccessToken(),
          'X-Origin': 'http://localhost:3000'

        },
        body: chunkBase64
      });
      try {
        requestUploadChunk.execute((ret) => {
          callbackUploadDone(ret, chunkBytesCount);
        });
      } catch (err) {
        return false;
      }
    }

    function chunkFile(file: any, callbackFileRead: any, $scope: any) {
      let fileSize = file.size;
      let offset = 0;
      let block = null;
      let wait = 1000;
      let fileReader: any = new FileReader();
      let checkUploadResult = (res: any, lastChunkSize: any) => {
        if (fileData.cancelled !== undefined && fileData.cancelled === true) {
          callback(false);
          return;
        }
        if (res === undefined) {
          offset += lastChunkSize;
          if (callbackProgress !== null && callbackProgress !== undefined) {
            callbackProgress((offset * 100) / fileSize);
          }
          block(offset, chunkSize, file);
        } else {
          if (res !== null && typeof (res) === 'object') { // we upload last chunk
            let settings = {
              'auditType': 1,
              'file_id': res.id,
              'storage_file_name': res.name,
              'file_parent_folder': archiDriveFileParentFolder,
              'file_name': archiDriveFileName
            };
            let successCallback = () => {
              callback(dropzoneId, res, fileData.name);
              callbackProgress(100);
            };
            let errorCallback = () => {
              //
            };
            $rootScope.audit(settings, successCallback, errorCallback);
            return;
          }
          if (res === false) {
            callback(dropzoneId, false, fileData.name);
            return;
          }
          setTimeout(
            function () {
              if (wait > 6000) {
                callback(dropzoneId, false, fileData.name);
                return;
              }
              block(offset, chunkSize, file);
              wait *= 2;
            }, wait + Math.floor(Math.random() * 1000) + 1);
        }
      };

      let fileReaderOnLoad: Function = (evt: any) => {
        let res: any;
        if (!evt) {
          // readAsBinaryString is missing (IE 11), so we use our method where the read data is
          res = callbackFileRead(fileReader.content, offset, checkUploadResult, $scope);
        } else {
          if (evt.target.error == null) {
            res = callbackFileRead(evt.target.result, offset, checkUploadResult, $scope);
          } else {
            return;
          }
        }
        if (offset >= fileSize) {
          return;
        }
      };

      block = (_offset, length, _file) => {
        let blob = _file.slice(_offset, length + _offset);
        fileReader.onload = fileReaderOnLoad;
        fileReader.onerror = (e) => {
          // it may be a folder, or an Error
          let _rootScope: any = ng.element($('html')).injector().get('$rootScope');
          _rootScope.alert('error', `In <span class='bold'>Archivia</span> puoi caricare soltanto file.`);
          callback(false);
          return;
        };

        let isIE = (FileReader.prototype.readAsBinaryString === undefined);

        if (!isIE) {
          fileReader.readAsBinaryString(blob);
        } else {
          fileReader.readAsBinaryStringForChunk(blob);
        }
      };
      block(offset, chunkSize, file);
    }

    request.execute(getUploadUrl);
  }


  getCodeSnippet(method: any, params: any) {
    let objConstruction = '// Declare your parameter object\n';
    objConstruction += 'var params = {};';
    objConstruction += '\n\n';
    let param = '// Initialize your parameters \n';
    params.forEach((i) => {
      param += `params['${i}'] = `;
      param += JSON.stringify(params[i], null, '\t');
      param += ';';
      param += '\n';
    });
    param += '\n';
    let methodCall = '// Make a request to the Google Cloud Storage API \n';
    methodCall += `var request = gapi.client.${method}(params);`;
    return objConstruction + param + methodCall;
  }
}

export const googleAPI: GoogleAPI = new GoogleAPI();

// extend FileReader for case of readAsBinaryString is missing (IE 11)
// http://stackoverflow.com/a/35170914/3207940
if (FileReader.prototype.readAsBinaryStringForChunk === undefined) {
  FileReader.prototype.readAsBinaryStringForChunk = (fileData) => {
    let binary = '';
    let pt = this;
    let reader = new FileReader();
    var readerResult: any = reader.result;
    reader.onload = (e) => {
      let bytes = new Uint8Array(readerResult);
      let length = bytes.byteLength;
      for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      // pt.result  - readonly so assign content to another property
      pt.content = binary;
      $(pt).trigger('onload');
    };
    reader.readAsArrayBuffer(fileData);
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/googleAPI.ts